import styled from "styled-components";

import { PixelPlaceholderLoader } from "@similarweb/ui-components";

export const ButtonSkelton = styled(PixelPlaceholderLoader).attrs({ width: "100px", height: "36px" })`
    border-radius: 20px;
    width: 100px;
    height: 36px;
`;

export const TextareaSkelton = styled(PixelPlaceholderLoader).attrs({ width: "100%", height: "100px" })`
    border-radius: 6px;
    width: 100%;
    height: 100px;
`;

export const TextInputSkelton = styled(PixelPlaceholderLoader).attrs({ width: "100%", height: "42px" })`
    border-radius: 6px;
    width: 100%;
    height: 42px;
`;

export const LabelSkelton = styled(PixelPlaceholderLoader).attrs({ width: "70px", height: "20px" })`
    border-radius: 6px;
    width: 70px;
    height: 20px;
`;
